import ApartmentView from './ApartmentView';

export default ApartmentView;
